import styled, { createGlobalStyle } from 'styled-components';

import { Theme } from 'utils/color/horizonTheme';

export const MessageStyles = createGlobalStyle`
  .ant-message-notice-content,
  .ant-notification-notice {
    background: ${({ theme }) => (theme.themeName === Theme.Dark ? theme.tertiaryBackgroundColor : theme.secondaryBackgroundColor)} !important;
    color: ${({ theme }) => theme.textColor};
  }

  .ant-notification-notice-message,
  .ant-notification-notice-description,
  .ant-notification-notice-close {
    color: ${({ theme }) => theme.secondaryTextColor} !important;
  }
  
  .ant-notification-notice-description .hotkeys-info {
    color: ${({ theme }) => theme.textColor} !important;
  }

  .ant-notification-notice {
    margin-bottom: unset !important;
  }
`;

export const StyledMessageDiv = styled.div`
  align-items: center;
  display: flex;

  > .anticon {
    margin: 0 !important;
    top: 3px !important;
  }

  > .anticon-close {
    color: ${({ theme }) => theme.secondaryTextColor} !important;
    &:hover {
      color: ${({ theme }) => theme.descriptionColor} !important;
    }
  }
`;

export const StyledMessageContent = styled.div`
  text-align: left;
  margin: 0 8px;
`;
